module.exports = __webpack_public_path__ + "img/w-explore-shake.ed3c3e78.svg";